<template>
  <v-alert
    v-if="me"
    :model-value="visible"
    class="mt-4 white--text"
    border="start"
    close-text="Close"
    elevation="1"
    color="deep-orange-lighten-1"
  >
    <h6 class="text-subtitle-2 deep-orange--text text--lighten-5">
      <span v-if="pending || pendingApproval">Account setup</span>
      <span v-else-if="rejected">Your account has been rejected</span>
      <span v-else-if="suspended">Your account has been suspended</span>
      <span v-else>Account status</span>
    </h6>
    <span v-if="pending">
      {{ me.first_name }}, your account is not fully setup. We need more
      information about your business <br />including banking information so you
      can start selling.
      <v-btn
        class="ml-2"
        color="primary"
        size="x-small"
        :to="{ name: 'onboarding' }"
      >
        <small>Continue setup</small>
      </v-btn>
    </span>
    <span v-else-if="pendingApproval">
      {{ me.first_name }}, your account is pending review. We'll notify you as
      soon as you're ready to go.
    </span>
    <span v-else-if="rejected">
      Unfortunately, your business isn’t eligible to sell on Orie because it
      doesn't meet our
      <nuxt-link :to="links.terms">Terms of Service</nuxt-link>. If you think
      this may be a mistake, please
      <nuxt-link :to="links.contact">contact us</nuxt-link>.
    </span>
    <span v-else-if="suspended">
      Unfortunately, your account has been suspended because it doesn't meet our
      <nuxt-link :to="links.terms">Terms of Service</nuxt-link>. If you think
      this may be a mistake, please
      <nuxt-link :to="links.contact">contact us</nuxt-link>.
    </span>
  </v-alert>
</template>

<script lang="ts">
export default defineComponent({
  name: "AccountStatus",
  setup() {
    const { me } = useAuth();
    const { links } = useAppConfig();

    const { pending, pendingApproval, rejected, suspended } =
      useAccountStatus();

    const visible = computed(
      () =>
        pending.value ||
        pendingApproval.value ||
        rejected.value ||
        suspended.value
    );

    return {
      me,
      visible,
      pending,
      pendingApproval,
      rejected,
      suspended,
      links,
    };
  },
});
</script>
